module.exports = "/static/Images/pt-br/Four.png";